import { render, staticRenderFns } from "./UsersVue.vue?vue&type=template&id=317616de&"
import script from "./UsersVue.vue?vue&type=script&lang=js&"
export * from "./UsersVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports